import React from 'react';
import { Heading, Text } from '@/Components/ui/typography';

function LoginHeader() {
  return (
    <div className="space-y-3 mb-2">
      <Heading level="h1" className="text-4xl font-bold text-foreground tracking-tight">
        Welcome Back
      </Heading>
      <Text size="base" variant="muted" className="text-muted-foreground leading-relaxed">
        Sign in to continue the journey of faster, fairer and smarter hiring.
      </Text>
    </div>
  );
}

export default LoginHeader;